import { getPrivateMessageRecent } from '@moal/api'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { CSVLink } from 'react-csv'
import { PRODUCT_CODE } from '../../../../utils/ENV'
import { toastError } from '../../../../utils/toast'
import Moaltip from '../../../Utilities/Tooltip'
import DateRangePicker from '../DateRangePicker'
import styles from '../Stats.module.css'

const ExportPrivateChat = () => {
  const [downloadData, setDownloadData] = useState([])
  const [fileName, setFileName] = useState('my-file.csv')

  const [scaleType, setScaleType] = useState('timeseries')

  const [startDate, setStartDate] = useState(
    moment().subtract(1, 'days').toDate()
  )
  const [endDate, setEndDate] = useState(moment().toDate())

  useEffect(() => {
    setDownloadData([])
  }, [startDate, endDate])

  const columns = useMemo(
    () => [
      {
        Header: 'Post Date',
        accessor: 'postDate'
      },
      {
        Header: 'Item Number',
        accessor: 'itemNumber'
      },
      {
        Header: 'Message ID',
        accessor: '_id'
      },
      {
        Header: 'Message',
        accessor: 'message'
      },
      {
        Header: 'From Name',
        accessor: 'user.userService.profile.name'
      },
      {
        Header: 'From User Service ID',
        accessor: 'user.userService._id'
      },
      {
        Header: 'From Customer Number',
        accessor: 'user.userService.customerNumber'
      },
      // {
      //   Header: 'To Name',
      //   accessor: 'toUser.userService.profile.name'
      // },
      // {
      //   Header: 'To User Service ID',
      //   accessor: 'toUser.userService._id'
      // },
      // {
      //   Header: 'To Customer Number',
      //   accessor: 'toUser.userService.customerNumber'
      // },
      {
        Header: 'To Everyone',
        accessor: 'toEveryone'
      },
      {
        Header: 'From Bot',
        accessor: 'fromBot'
      },
      {
        Header: 'Highlighted',
        accessor: 'highlighted'
      },
      {
        Header: 'Edited',
        accessor: 'edited'
      }
    ],
    []
  )

  const loadData = async () => {
    const messages = await buildMessageList()
    if (messages) {
      if (messages.length === 0) {
        toastError('No Data in this Date Range')
        return
      }

      const start = moment(startDate).toISOString().split('T')[0]
      const end = moment(endDate).toISOString().split('T')[0]
      setFileName(`${PRODUCT_CODE}-private-messages-${start}-${end}.csv`)
      const toDownload = []

      const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj)
      }

      messages.forEach((data) => {
        const dataRow = {}
        for (let colIndex = 0; colIndex < columns.length; colIndex++) {
          const dataPoint = columns[colIndex].accessor
          if (dataPoint) {
            dataRow[columns[colIndex].Header] = getNestedValue(data, dataPoint)
          }
        }
        toDownload.push(dataRow)
      })
      setDownloadData(toDownload)
    }
  }

  const buildMessageList = async () => {
    const messages = []
    let cursor = moment(endDate).add(1, 'day').format('YYYY-MM-DD')
    for (let i = 0; i < 100; i++) {
      const res = await getPrivateMessageRecent({
        token: localStorage.getItem('authToken'),
        itemNumber: PRODUCT_CODE,
        ...(cursor ? { loadMore: cursor } : {})
      })
      const batch =
        res && res.status === 200 && Array.isArray(res.data) ? res.data : []
      if (batch.length === 0) break

      messages.push(...batch)

      const oldest = batch[batch.length - 1].postDate
      if (moment(startDate).isAfter(oldest)) break

      const next = moment(oldest).format('YYYY-MM-DD')
      if (next === cursor) break // stall guard
      cursor = next
    }
    return messages
  }

  if (downloadData === null) {
    return (
      <div className={styles.wrapper}>
        <div className="flex items-center justify-center my-auto">
          <p className="animate-pulse">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <header className="flex items-center gap-2">
        <h2>Export Private Chat</h2>
        <Moaltip>
          This downloadable table displays detailed Private message data
          including: Post Date, Message ID, Message, Hidden, Reply To Message
          ID, User Service ID, Customer Number, Name, and Role.
        </Moaltip>
      </header>

      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        scaleType={scaleType}
        setScaleType={setScaleType}
      />
      {downloadData.length <= 0 && (
        <button className="button-confirm mx-2 mb-2 w-fit" onClick={loadData}>
          Load Data
        </button>
      )}
      {downloadData.length > 0 && (
        <CSVLink
          className="button-confirm mx-2 mb-2 w-fit"
          data={downloadData}
          filename={fileName}
        >
          Download
        </CSVLink>
      )}
    </div>
  )
}

export default ExportPrivateChat
